
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "ac53b4f5-0829-4513-80cb-57c3fd3dd87d"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/app/base/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
